import { message } from 'antd'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ValidateErrorEntity } from 'rc-field-form/lib/interface'

function handleFormError(errorInfo: ValidateErrorEntity) {
	errorInfo.errorFields.forEach(value => {
		message.error(value.errors[0])
	})
}

export default handleFormError
